import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import * as actions from "actions/actions";

import { authLinks } from "data/links";

import { Login, Join } from "components/ProfileMenu/styles";

const nextURL = () => {
    let toEncode;

    if (window.location.search) {
        // if coming from a search path:
        toEncode = `${window.location.pathname}${window.location.search}`;
    } else {
        toEncode = window.location.pathname;
    }

    const encodedUrl = encodeURIComponent(toEncode);

    return encodedUrl;
};

const LoginLinkUnwrapped = ({ redirect, isHeroSearchV2 }) => {
    const encodedUrl = nextURL();

    const handleLogin = e => {
        e.preventDefault();
        redirect(`${authLinks.login.href}?next=${encodedUrl}`);
    };

    return (
        <Login
            data-test="login-link"
            href={authLinks.login.href}
            onClick={handleLogin}
            isHeroSearchV2={isHeroSearchV2}
        >
            {authLinks.login.text}
        </Login>
    );
};

const LoginLink = connect(null, { redirect: actions.redirect })(
    LoginLinkUnwrapped
);

LoginLink.propTypes = {
    isHeroSearchV2: PropTypes.bool
};

const JoinLinkUnwrapped = ({ redirect, isHeroSearchV2 }) => {
    const encodedUrl = nextURL();

    const handleJoin = e => {
        e.preventDefault();
        redirect(`${authLinks.signup.href}?next=${encodedUrl}`);
    };

    return (
        <Join
            href={authLinks.signup.href}
            onClick={handleJoin}
            isHeroSearchV2={isHeroSearchV2}
        >
            {authLinks.signup.text}
        </Join>
    );
};

const JoinLink = connect(null, { redirect: actions.redirect })(
    JoinLinkUnwrapped
);

JoinLink.propTypes = {
    isHeroSearchV2: PropTypes.bool
};

export { LoginLink, JoinLink };
